// @flow
import * as React from 'react';

export type ActiveKind = 'transferable' | 'creatable' | 'unavailable' | null;

export const ActiveKindContext: React.Context<ActiveKind> =
  React.createContext<ActiveKind>(null);

export function useActiveKind(): ActiveKind {
  return React.useContext(ActiveKindContext);
}
